export default __webpack_public_path__ + "static/media/992.4c19e2ba.png";